import React, { useEffect, useRef, useState, useContext } from "react";
import "./ajiPage.scss";
import axios from "axios";
import ajiChatbotIcon from "../../../../../../../images/aji_image/ajiChatbotIcon.svg";
import sendMessageIcon from "../../../../../../../images/aji_image/sendMessageIcon.svg";
import sendMessageDisableIcon from "../../../../../../../images/aji_image/sendMessageDisableIcon.svg";
import userIcon from "../../../../../../../images/aji_image/userIcon.svg";
import ajiConfig from "./ajiConfig";
import MessageCard from "./components/messageCard/MessageCard";
import SendMessage from "./components/sendMessage/SendMessage";
import TopPanel from "./components/topPanel/TopPanel";
import { StoreContext } from "../../../../../../store/StoreProvider";
import LoadingMessageCard from "./components/messageCard/LoadingMessageCard";
import StyledMain from "../component/StyledMain";
import ApiUrls from "../../../../../../api/project/ApiUrls";

const AjiPage = () => {
  const [chatMessage, setChatMessage] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isChatting, setIsChatting] = useState(false);
  const [monthSub, setMonthSub] = useState(true);
  const [QACount, setQACount] = useState(0);
  const scrollToBottomRef = useRef(null);
  const [state, _] = useContext(StoreContext);
  const { sna } = state;
  const { open } = sna.sidebar;
  const locQA = "QACount";

  useEffect(() => {
    const localStorageQACount = parseInt(localStorage.getItem(locQA), 10) || 0;

    setQACount(localStorageQACount);
  }, [chatMessage]);

  useEffect(() => {
    const resetQACount = () => {
      const now = new Date();
      if (
        now.getHours() === ajiConfig.freeQuotaUpdateHour &&
        now.getMinutes() === ajiConfig.freeQuotaUpdateMinute
      ) {
        localStorage.setItem(locQA, "0");
      }
    };

    const interval = setInterval(resetQACount, 60000);

    return () => clearInterval(interval);
  }, []);

  // 自動滾動到最新問答
  useEffect(() => {
    if (scrollToBottomRef.current) {
      scrollToBottomRef.current.scrollTo({
        top: scrollToBottomRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [chatMessage]);

  // 取得ID現在時間
  const getCurrentIdAndTime = () => {
    const timestamp = Date.now();
    const time = new Date(timestamp);
    const padZero = (num) => (num < 10 ? `0${num}` : num);
    const timeDetails = {
      year: time.getFullYear(),
      month: padZero(time.getMonth() + 1),
      date: padZero(time.getDate()),
      hour: padZero(time.getHours()),
      minute: padZero(time.getMinutes()),
    };
    return {
      id: `QAA_${timestamp}_${Math.floor(Math.random() * 10000)}`,
      time: `${timeDetails.year}.${timeDetails.month}.${timeDetails.date} ${timeDetails.hour}:${timeDetails.minute}`,
      timestamp,
    };
  };

  // 獲取GPT回答
  const getGptAnswer = async (copyUserInput) => {
    try {
      const gptResponse = await axios.post(
        ApiUrls.getGptAnswerUrl,
        { question: copyUserInput },
        { timeout: 120000 }
      );
      const gptAnswer = gptResponse.data.answer;
      const gptSourceArray = gptResponse.data.source;

      const { id, time, timestamp } = getCurrentIdAndTime();

      const answerMessage = {
        id,
        type: ajiConfig.msgType.ai,
        message: gptAnswer,
        rate: "",
        dataTime: time,
        timestamp,
      };

      if (gptSourceArray) {
        answerMessage.dataSource = {
          title: ajiConfig.sourceTitle,
          source: gptSourceArray,
        };
      }

      setChatMessage((prevMessages) => [...prevMessages, answerMessage]);
      setIsChatting(false);
    } catch (e) {
      console.log(e);
      const { id, time, timestamp } = getCurrentIdAndTime();

      const answerMessage = {
        id,
        type: ajiConfig.msgType.ai,
        message: `AI額度已達上限，請聯絡網站管理者`,
        rate: "",
        dataTime: time,
        timestamp,
      };

      setChatMessage((prevMessages) => [...prevMessages, answerMessage]);
      setIsChatting(false);
    }
  };

  const recordSendCount = () => {
    if (!isChatting && !monthSub && QACount < ajiConfig.quota) {
      localStorage.setItem(locQA, QACount + 1);
    }
  };

  // 發送使用者問題
  const handleSendMessage = () => {
    recordSendCount();

    if ((QACount < ajiConfig.quota || monthSub) && !isChatting) {
      setIsChatting(true);

      // const copyUserInput = userInput;

      if (userInput) {
        const { id, time, timestamp } = getCurrentIdAndTime();
        setChatMessage((prevMessages) => [
          ...prevMessages,
          {
            id,
            type: ajiConfig.msgType.user,
            message: userInput,
            dataTime: time,
            timestamp,
          },
        ]);
        setUserInput("");
        getGptAnswer(userInput);
      } else {
        setIsChatting(false);
      }
    }
  };

  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };

  return (
    <StyledMain className="chatbotGroup" open={open}>
      <TopPanel
        chatMessage={chatMessage}
        isChatting={isChatting}
        monthSub={monthSub}
        QACount={QACount}
      />
      <div className="chatbot">
        <div
          className="chatRoom"
          style={{
            justifyContent: chatMessage.length === 0 ? "center" : "start",
          }}
          ref={scrollToBottomRef}
        >
          <div>
            <h2 className="chatbotTitle">{ajiConfig.title}</h2>
            <p className="chatbotContent">{ajiConfig.firstContent}</p>
            <p className="chatbotContent">{ajiConfig.secondContent}</p>
          </div>
          <div className="messageRoom">
            {chatMessage.map((messageObj, index) => (
              <MessageCard
                messageObj={messageObj}
                ajiChatbotIcon={ajiChatbotIcon}
                userIcon={userIcon}
                chatMessage={chatMessage}
                setChatMessage={setChatMessage}
                // eslint-disable-next-line react/no-array-index-key
                key={index}
              />
            ))}
            {isChatting && <LoadingMessageCard />}
          </div>
        </div>
        <SendMessage
          handleInputChange={handleInputChange}
          userInput={userInput}
          handleSendMessage={handleSendMessage}
          isChatting={isChatting}
          sendMessageDisableIcon={sendMessageDisableIcon}
          sendMessageIcon={sendMessageIcon}
          monthSub={monthSub}
          QACount={QACount}
        />
      </div>
    </StyledMain>
  );
};

export default AjiPage;
